import { useCappsLandlordApplicationDataWebApiHandler_getApplicationStatus } from '@zg-rentals/ts-capps-client-react-query';

export function useGetApplication({ listingAlias, applicationId }: { listingAlias: string; applicationId: string }) {
  return useCappsLandlordApplicationDataWebApiHandler_getApplicationStatus({ listingAlias, applicationId });
}
